<mat-form-field [formGroup]="form.formGroup">
  <mat-label>Type</mat-label>
  <mat-select [formControlName]="form.formControlNames.type">
    <mat-option *ngFor="let type of CarabinerType | keyvalue"
    [value]="type.value">{{ type.value }}</mat-option>
  </mat-select>
</mat-form-field>
